import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { SolarLightReachDisclosuresDto } from "../dto/solar-lightreach.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * LightReach disclosures for a Solar Proposal's credit application. The
 * submit attests the `{id, version}` of each one shown, so the list is never
 * served from cache: each opening reads the versions LightReach publishes now.
 */
export default function useSolarLightReachDisclosures(
  proposalId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
): UseQueryResult<SolarLightReachDisclosuresDto> {
  return useQuery({
    queryKey: queryKeys.solarProposal.lightReachDisclosures(proposalId ?? ``),
    queryFn: () =>
      solarProposalService.getLightReachDisclosures(proposalId ?? ``),
    enabled: Boolean(proposalId) && enabled,
    staleTime: 0,
    cacheTime: 0,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
